import React from 'react'
import { IOrganisationsProps } from '../../containers/AdminOrganisations/OrganisationsContainer'

import DashboardCard from 'components/DashboardCard/DashboardCard'
import OrganisationsList from 'containers/OrganisationsList/OrganisationsList'
import AddOrganisation from 'containers/AddOrganisation/AddOrganisation'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { AiOutlineSearch } from 'react-icons/ai'
import { useThrottle } from 'hooks/useThrottle'

const Organisations: React.FC<IOrganisationsProps> = ({
  createOrganisationStatus,
  removeOrganisation,
  updateOrganisationName,
}) => {
  const [searchText, setSearchText] = useState<string>('')
  const throttledSearchText = useThrottle(searchText, 300)

  const { t } = useTranslation()
  return (
    <DashboardCard style={{ display: 'block' }}>
      <div className="flex flex-col mb-6">
        <span className="mb-4">{t('AddOrganisation.addOrganisation')}</span>
        <AddOrganisation createOrganisationStatus={createOrganisationStatus} />
      </div>
      <span>{t('Organisations.handleOrganisations')}</span>
      <div className="max-w-[300px] flex items-center space-x-2 py-2">
        <AiOutlineSearch className="text-gray-600 text-xl shrink-0" />
        <input
          onChange={(e) => setSearchText(e.target.value)}
          placeholder={t('general.search')}
          className="placeholder-gray-400 text-sm border-none text-gray-700 outline-hidden w-full h-[30px]"
        />
      </div>
      <OrganisationsList
        searchText={throttledSearchText}
        removeOrganisation={removeOrganisation}
        updateOrganisationName={updateOrganisationName}
      />
    </DashboardCard>
  )
}

export default Organisations
